'use client';
import React from 'react';
import { useTranslations } from 'next-intl';

const FooterTitle = ({ title, className }) => {
  const t = useTranslations('common');

  return (
    <h2 className={`text-dark mb-4 font-bold max-lg:text-sm ${className}`}>
      {t(title)}
    </h2>
  );
};

export default FooterTitle;
